import { render } from "./DDropdownSpacer.vue?vue&type=template&id=724ea622&scoped=true"
import script from "./DDropdownSpacer.vue?vue&type=script&lang=js"
export * from "./DDropdownSpacer.vue?vue&type=script&lang=js"

import "./DDropdownSpacer.vue?vue&type=style&index=0&id=724ea622&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724ea622"]])

export default __exports__